import React from "react";

const PermissionButton = ({ active, onClick }) => {
    return (
        <div
            className={`perm-btn ${active ? "active" : "inactive"}`}
            onClick={onClick}
        >
            {active ? "✔" : "✖"}
        </div>
    );
};

export default PermissionButton;